var _circle, _circle2, _circle3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelegate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UsersIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.009,
    height: 59.672,
    viewBox: "0 0 61.009 59.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 8.019,
    cy: 8.019,
    r: 8.019,
    transform: "translate(44.971 34.814)",
    fill: "#aae2d0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 8.019,
    cy: 8.019,
    r: 8.019,
    transform: "translate(0 8.887)",
    fill: "#aae2d0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 8.019,
    cy: 8.019,
    r: 8.019,
    transform: "translate(44.904 8.887)",
    fill: "#aae2d0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1552",
    "data-name": "Group 1552",
    transform: "translate(4.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M12.076,30.652a4.076,4.076,0,1,1,4.076-4.076h0A4.05,4.05,0,0,1,12.076,30.652Zm0-7.016a2.94,2.94,0,1,0,2.94,2.94h0A2.966,2.966,0,0,0,12.076,23.636Z",
    transform: "translate(-8 -9.47)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M78.843,30.619a4.11,4.11,0,1,1,4.076-4.143h0A4.065,4.065,0,0,1,78.843,30.619Zm0-7.016a2.94,2.94,0,1,0,2.94,2.94h0A2.966,2.966,0,0,0,78.843,23.6Z",
    transform: "translate(-30.13 -9.437)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M12.076,69.052a4.076,4.076,0,1,1,4.076-4.076h0A4.05,4.05,0,0,1,12.076,69.052Zm0-7.016a2.94,2.94,0,1,0,2.94,2.94,2.923,2.923,0,0,0-2.94-2.94Z",
    transform: "translate(-8 -22.21)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M78.843,69.019a4.11,4.11,0,1,1,4.076-4.143v.067A4.05,4.05,0,0,1,78.843,69.019Zm0-7.016a2.94,2.94,0,1,0,2.94,2.94A2.966,2.966,0,0,0,78.843,62Z",
    transform: "translate(-30.13 -22.177)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1546",
    "data-name": "Group 1546",
    transform: "translate(25.66 7.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M47,24.927a.6.6,0,0,1-.6-.6V14.1a.6.6,0,1,1,1.2,0V24.392a.589.589,0,0,1-.6.535Z",
    transform: "translate(-46.4 -13.5)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M47,76.027a.6.6,0,0,1-.6-.6h0V65.2a.6.6,0,1,1,1.2,0h0V75.492A.546.546,0,0,1,47,76.027Z",
    transform: "translate(-46.4 -30.454)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1547",
    "data-name": "Group 1547",
    transform: "translate(6.719 18.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M27.307,36.2c-.134,0-.2,0-.267-.067l-8.687-5.078a.559.559,0,0,1-.2-.8.572.572,0,0,1,.8-.2h0l8.687,5.078a.619.619,0,0,1,.2.8A.608.608,0,0,1,27.307,36.2Z",
    transform: "translate(-18.056 -29.956)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M71.455,62.448c-.134,0-.2,0-.267-.067l-8.821-5.212a.584.584,0,0,1,.6-1h0l8.754,5.212a.559.559,0,0,1,.2.8.447.447,0,0,1-.468.267Z",
    transform: "translate(-32.669 -38.63)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1548",
    "data-name": "Group 1548",
    transform: "translate(6.883 17.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M18.835,62.355a.563.563,0,0,1-.468-.267.638.638,0,0,1,.2-.8h0l8.553-5.212a.643.643,0,0,1,.8.267.554.554,0,0,1-.2.735l-8.553,5.212A.727.727,0,0,1,18.835,62.355Z",
    transform: "translate(-18.3 -38.567)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M62.5,36.248a.6.6,0,0,1-.6-.6.563.563,0,0,1,.267-.468l8.754-5.212a.584.584,0,1,1,.6,1h0l-8.754,5.212C62.7,36.248,62.635,36.248,62.5,36.248Z",
    transform: "translate(-32.766 -29.9)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1549",
    "data-name": "Group 1549",
    transform: "translate(3.408 5.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M34.414,79.764c-.134,0-.2,0-.267-.067L17.976,70.276a.555.555,0,0,1-.134-.8.608.608,0,0,1,.735-.2L34.748,78.7a.559.559,0,0,1,.2.8h0A.825.825,0,0,1,34.414,79.764Z",
    transform: "translate(-14.635 -30.13)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M18.2,21.265A.825.825,0,0,1,17.667,21a.638.638,0,0,1,.2-.8l16.171-9.422a.643.643,0,0,1,.8.267.554.554,0,0,1-.2.735L18.536,21.2A2.894,2.894,0,0,1,18.2,21.265Z",
    transform: "translate(-14.593 -10.722)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M13.7,52.545a.6.6,0,0,1-.6-.6V33.7a.6.6,0,1,1,1.2,0V52.011A.589.589,0,0,1,13.7,52.545Z",
    transform: "translate(-13.1 -18.146)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1550",
    "data-name": "Group 1550",
    transform: "translate(29.201 5.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M52.3,79.733a.825.825,0,0,1-.535-.267.638.638,0,0,1,.2-.8h0l16.1-9.422a.575.575,0,0,1,.668.936.233.233,0,0,1-.134.067L52.569,79.666A.4.4,0,0,1,52.3,79.733Z",
    transform: "translate(-51.7 -30.018)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M68.305,21.091c-.134,0-.2,0-.267-.067l-15.97-9.355a.638.638,0,0,1-.2-.8.6.6,0,0,1,.8-.2l15.97,9.355a.559.559,0,0,1,.2.8A.608.608,0,0,1,68.305,21.091Z",
    transform: "translate(-51.733 -10.6)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M81,52.507a.6.6,0,0,1-.6-.6h0V33.663a.605.605,0,1,1,1.2-.134V51.972A.589.589,0,0,1,81,52.507Z",
    transform: "translate(-61.217 -18.027)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1551",
    "data-name": "Group 1551",
    transform: "translate(14.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M45.676,11.152a4.076,4.076,0,1,1,4.076-4.076h0A4.05,4.05,0,0,1,45.676,11.152Zm0-7.016a2.94,2.94,0,1,0,2.94,2.94A2.923,2.923,0,0,0,45.676,4.136Z",
    transform: "translate(-33.314 -3)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M45.676,88.252a4.076,4.076,0,1,1,4.076-4.076h0A4.137,4.137,0,0,1,45.676,88.252Zm0-7.083a2.94,2.94,0,1,0,2.94,2.94A2.966,2.966,0,0,0,45.676,81.169Z",
    transform: "translate(-33.314 -28.58)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M41.562,53.824A12.362,12.362,0,1,1,53.924,41.462h0A12.377,12.377,0,0,1,41.562,53.824Zm0-23.588A11.226,11.226,0,1,0,52.788,41.462,11.208,11.208,0,0,0,41.562,30.236Z",
    transform: "translate(-29.2 -11.659)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 4.343,
    cy: 4.343,
    r: 4.343,
    transform: "translate(22.051 21.517)",
    fill: "none",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M43.177,59.692a12.232,12.232,0,0,1-7.685-3.074c-.334-.267-.468-.468-.4-.8,1.069-4.811,3.675-7.217,8.219-7.217s7.217,2.673,8.286,7.484a.383.383,0,0,1-.134.468A11.776,11.776,0,0,1,43.177,59.692Z",
    transform: "translate(-16.983 -18.129)",
    fill: "none",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegate);
export default __webpack_public_path__ + "static/media/delegate.40e16317.svg";
export { ForwardRef as ReactComponent };